import { render } from "./taskEval.vue?vue&type=template&id=3a49d48b"
import script from "./taskEval.vue?vue&type=script&lang=js"
export * from "./taskEval.vue?vue&type=script&lang=js"

import "./taskEval.vue?vue&type=style&index=0&id=3a49d48b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__